require("../../node_modules/jquery-ui/ui/widget");
require("../../node_modules/jquery-ui/ui/effect");
require("../../node_modules/jquery-ui/ui/core");
require("../../node_modules/jquery-ui/ui/widgets/datepicker");
require("../../node_modules/jquery-datetimepicker/build/jquery.datetimepicker.full");

module.exports = {
  init: () => {
    function getFormattedDate(date) {
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear().toString().slice(2);
      return day + "-" + month + "-" + year;
    }

    var logic = function (currentDateTime) {
      if (currentDateTime.getDay() == 0) {
        this.setOptions({
          minTime: "11:00",
          maxTime: "16:30",
        });
      } else if (currentDateTime.getDay() == 6) {
        this.setOptions({
          minTime: "11:00",
          maxTime: "16:30",
        });
      } else {
        this.setOptions({
          minTime: "9:00",
          maxTime: "18:00",
        });
      }
    };

    $(".datepicker").each(function (i, obj) {
      $(this).datetimepicker({
        lang: "da",
        minDate: getFormattedDate(new Date()),
        format: "d/m/Y H:i",
        step: 30,
        dayOfWeekStart: "1",
        onChangeDateTime: logic,
        onShow: logic,
        onGenerate: function (ct) {
          jQuery(this).find(".xdsoft_date").removeClass("xdsoft_disabled");
        },
      });
    });
  },
};
